import React, { useEffect, useState } from 'react';
import HeaderImageApparelTwoColumns from '../../assets/apparel_mobile.webp';
import HeaderImageApparel from '../../assets/apparel_desktop.webp';
import Button from '../../components/Button';
import { StoryblokRichtext, render } from 'storyblok-rich-text-react-renderer';
// import Link from '../base/Link';

// import { defaultLocale, locales } from '../../translations/i18nConfig';
import { useTranslation } from 'react-i18next';
// import { useLocation } from 'react-router-dom';

import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';

import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';

import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
  useMediaQuery,
} from '@mui/material';
import { StoryblokLink } from '../../types/StoryblokLink';

type ImageType = {
  _editable: string;
  _uid: string;
  filename: string;
  alt: string;
  title: string;
};

type ApparelItem = {
  design_name: string;
  available_sizes: string;
  images: ImageType[];
};

type ApparelProps = {
  blok: {
    headline?: string;
    description?: StoryblokRichtext;
    quote?: string;
    author?: string;
    items: ApparelItem[];
    ctaText: string;
    ctaLink: StoryblokLink;
    allApparel?: boolean;
  };
};

const Apparel = ({ blok }: ApparelProps) => {
  const isTablet = useMediaQuery('(min-width: 768px)');
  const isDesktop = useMediaQuery('(min-width: 1120px)');

  const getCols = () => (isDesktop ? 2 : isTablet ? 1 : 1);

  useEffect(() => {
    const itemsToPreload = blok.allApparel
      ? blok.items
      : blok.items.slice(0, 2);

    itemsToPreload.forEach((item) => {
      const imgPrimary = new Image();
      imgPrimary.src = item.images[0].filename;

      if (item.images[1]?.filename) {
        const imgHover = new Image();
        imgHover.src = item.images[1].filename;
      }
    });
  }, [blok.items, blok.allApparel]);

  const handleMouseEnter = (e: React.MouseEvent, hoverSrc?: string) => {
    const img = e.currentTarget.querySelector('img');
    if (img && hoverSrc) img.src = hoverSrc;
  };

  const handleMouseLeave = (e: React.MouseEvent, originalSrc?: string) => {
    const img = e.currentTarget.querySelector('img');
    if (img && originalSrc) img.src = originalSrc;
  };

  const { t } = useTranslation();
  // const location = useLocation();

  // const pathSegments = location.pathname.split('/').filter(Boolean);

  // const locale = locales.includes(pathSegments[0])
  //   ? pathSegments[0]
  //   : defaultLocale;

  // const apparelLink = locale === defaultLocale ? '/team' : `/${locale}/team`;

  const [open, setOpen] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  return (
    <div className='relative bg-flieder-soft-background z-0'>
      <div className='relative z-[-2] w-full'>
        <picture style={{ width: '100vw', boxSizing: 'content-box' }}>
          <source
            media='(max-width: 767px)'
            srcSet={HeaderImageApparelTwoColumns}
          />
          <source media='(min-width: 767px)' srcSet={HeaderImageApparel} />
          <img
            src={HeaderImageApparel}
            alt='Aliens Exist'
            style={{ maxWidth: '104.5%', marginLeft: '-2.25%' }}
          />
        </picture>
      </div>

      <div className='container items-start mx-auto max-w-container pt-[90px] pb-[40px]'>
        <div className='flex flex-col tablet:flex-row justify-between'>
          <div className='mb-6 lg:mb-0 tablet:mr-36'>
            {blok.headline && (
              <h3 className='text-[#1d243d] font-bold border-t border-b mb-2 style-2-mobile phone:style-2 tablet:w-[296px] py-1'>
                {blok.headline}
              </h3>
            )}
            {blok.description && (
              <div className='mb-4 style-1-mobile phone:style-1 tablet:w-[296px]'>
                {render(blok.description)}
              </div>
            )}

            {blok.ctaText && blok.ctaLink && (
              <Button
                type='submit'
                label={blok.ctaText}
                storyblokLink={blok.ctaLink}
                customvariant='filled'
              />
            )}

            {blok.quote && (
              <div className='text-flieder border-y border-t-black mb-2 mt-8 py-6 style-1-mobile phone:style-24 tablet:w-[296px]'>
                {blok.quote}
              </div>
            )}
            {blok.author && (
              <div className='mb-4 style-1-mobile phone:style-1 tablet:w-[296px]'>
                {blok.author}
              </div>
            )}
          </div>

          <div>
            <ImageList
              sx={{ width: '100%', height: 'auto' }}
              cols={getCols()}
              gap={33}
            >
              {(blok.allApparel ? blok.items : blok.items.slice(0, 4)).map(
                (item, idx) => (
                  <ImageListItem key={idx}>
                    <button
                      className='w-full h-full class'
                      {...(item.images[1]?.filename && {
                        onMouseEnter: (e) =>
                          handleMouseEnter(e, item.images[1].filename),
                        onMouseLeave: (e) =>
                          handleMouseLeave(e, item.images[0].filename),
                      })}
                      onClick={() => {
                        setSelectedIndex(idx);
                        setOpen(true);
                      }}
                    >
                      <img
                        src={item.images[0]?.filename}
                        alt={item.design_name}
                        className='w-full h-auto object-cover'
                        loading='lazy'
                      />
                    </button>
                    <ImageListItemBar
                      title={
                        <span className='text-black style-23-mobile tablet:style-23 !leading-[115%]'>
                          {item.design_name}
                        </span>
                      }
                      subtitle={
                        <span className='text-flieder style-23-mobile tablet:style-23 !leading-[115%]'>
                          {t('available sizes')}: {item.available_sizes}
                        </span>
                      }
                      position='below'
                    />
                  </ImageListItem>
                ),
              )}
            </ImageList>
            {/* {!blok.allApparel && (
              <div className='flex justify-start border-t border-b text-black w-full mt-[42px] style-5-mobile py-1'>
                <Link
                  href={apparelLink}
                  label={t('show_all_apparel')}
                  color='black'
                  hoverColor='black'
                />
              </div>
            )} */}
          </div>
        </div>
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={
          selectedIndex !== null
            ? blok.items[selectedIndex].images.map((img) => ({
                src: img.filename,
                alt: img.alt,
              }))
            : []
        }
        plugins={[Thumbnails, Zoom]}
      />
    </div>
  );
};

export default Apparel;
